import React from 'react';
import { Box, styled, Typography } from '@mui/material';

const StyledBox = styled(Box)(({ theme }) => ({
    img: {
            width: "29px",
            height: "29px",
            display: "inline-block",
            marginRight: "8px"
    }
}));

export const SvgIconWrapper: React.FC<{ children: React.ReactNode }> = (props) => {
    return (
        <StyledBox>
            {props.children}
        </StyledBox>
    );
};
